module.exports = __webpack_public_path__ + "img/access-facebook-effect_bg.ed061c36.png";